import {graphql} from 'react-relay/hooks';

export const graphqlWhoamiNextQuery = graphql`
  query graphqlWhoamiNextQuery {
      whoamiNext {
          id
          username
          email
          version
          balance
          pending {
              hash
              amount
          }
          vibe {
              username
          }
      }
  }
`;

export const graphqlWhoamiNextConditionalQuery = graphql`
  query graphqlWhoamiNextConditionalQuery($includeWhoamiNext: Boolean = true) {
      whoamiNext @include(if: $includeWhoamiNext) {
          id
          username
          email
          version
          vibe {
              username
          }
      }
  }
`;
